import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum GifIconVariant {
  DEFAULT = 'default',
}

interface IGifIconProps extends IConDefaultType {
  variant?: GifIconVariant;
}

function GifIcon({ color, className, size = 24, rotate, flip, variant = GifIconVariant.DEFAULT }: IGifIconProps) {
  const fill = color || EColorMap.gray_3;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === GifIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4H16C18.2091 4 20 5.79086 20 8V16C20 18.2091 18.2091 20 16 20H8C5.79086 20 4 18.2091 4 16V8C4 5.79086 5.79086 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2H16C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8ZM10.8 10.2V9H8.4C7.07452 9 6 10.0745 6 11.4V12.6C6 13.9255 7.07452 15 8.4 15H9.6C10.2628 15 10.8 14.4628 10.8 13.8V11.4H8.4V12.6H9.6V13.8H8.4C7.73726 13.8 7.2 13.2628 7.2 12.6V11.4C7.2 10.7372 7.73726 10.2 8.4 10.2H10.8ZM13.2 15V9H12V15H13.2ZM18 9V10.2H15.6V11.4H18V12.6H15.6V15H14.4V9H18Z"
            fill={fill}
          />
        </svg>
      )}
    </i>
  );
}

export default GifIcon;
